import { createContext, useContext } from 'react';

// What a Create screen is making and for whom. The Hook, Caption, Image and
// Video steps read it to prefill fields and to add the product, ICP and brand
// voice to their prompts.
export const CreateContext = createContext({
    product: null,
    icp: null,
    promptContext: '',
    contentType: '',
    seed: null, // { topic, hook, platform } when opened from a planned post
    embedded: false, // true inside a Create screen, which has its own title
});

export const useCreateContext = () => useContext(CreateContext);
